import React, {
  FC,
  useRef,
  useState,
  useEffect,
  useContext,
  useCallback,
} from 'react'

import screenfull from 'screenfull'
import ReactPlayer from 'react-player'
import { isMobile } from 'react-device-detect'
import axios from 'axios'
import axiosRetry from 'axios-retry'
import ApiURL from '../../Api/ApiUrl'
import cookie from 'react-cookies'
import * as rax from 'retry-axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import GenericMobileTopNavigation from '../../GenericComponents/GenericMobileTopNavigation'
import history from '../../history'
import AppContext from '../../context/appContext'
import { notify } from 'react-notify-toast'
import { getOffset } from '../../utils/timeOffset'

// import { useCast } from 'react-chromecast'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  useParams,
} from 'react-router-dom'

import { PlayerBox, playerInlineStyles } from './styles/VideoScreenStyles'

import {
  getSpecificVideo,
  getSpecificVideoStatus,
  getAllUserWatchedVideosByFolder,
  setTemporaryVideoStatus,
  getTemporaryVideoStatus,
  toggleFavoriteVideo,
  standardVideoCreateStatus,
  getStandardVideoStatus,
  setStandardVideoLocked,
  setStandardVideoWatched,
} from '../../Api/videoApi'

import {
  setChallengeVideoStatus,
  setChallengeVideoLocked,
  getChallengeStatuses,
  setChallengeVideoWatched,
} from '../../Api/challengesApi'

// import { createAxiosResponseInterceptor } from '../../Api/userAuthApi'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
// import NavigationBar from '../shared/NavigationBar/NavigationBar.jsx'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'

import NavigationBar from '../NavigationBar/NavigationBar'

import getQualityVideo from './helpers/getVideoQuality'

import PlayerControls from './views/PlayerControls'
import Navigation from '../Challenges/components/Navigation/Navigation'

interface VideoPlayerProps {
  albumName: string
  isIntro: boolean
  videoId: number
  videoOrder: number
  albumId: number
  challengeMode?: boolean
  videoName?: string
  isFav: boolean
}

const VideoPlayer: FC<VideoPlayerProps> = ({
  albumName,
  isIntro,
  videoId,
  videoOrder,
  albumId,
  challengeMode,
  videoName,
  isFav,
}) => {
  const playerRef: any = useRef(null)
  const controlsRef: any = useRef(null)
  const playerContainerRef: any = useRef(null)

  // let { videoId } = useParams()

  const [isVideoPlaying, setVideoPlaying] = useState(false)
  const [playedSeconds, setPlayedSeconds] = useState(0)
  const [playedPercentage, setPlayedPercentage] = useState(0)
  const [isFullscreen, setFullscreen] = useState(false)
  const [isVideoLocked, setVideoLocked] = useState(false)
  const [isVideoWatched, setVideoWatched] = useState(false)
  const [video, setVideo] = useState(Object)
  const [isVideoFav, setVideoFav] = useState(false)
  const [isStatusCreated, setStatusCreated] = useState(false)
  const [apiStatusId, setApiStatusId] = useState()
  const [currentVideoStatus, setCurrentVideoStatus] = useState(
    Object || undefined
  )
  const [shouldHideControls, setHideControls] = useState(true)
  const [isHorizontalMobile, setHorizontalMobile] = useState(false)

  const appContext = useContext(AppContext)

  useEffect(() => {
    document.addEventListener('fullscreenchange', (event) => {
      // document.fullscreenElement will point to the element that
      // is in fullscreen mode if there is one. If there isn't one,
      // the value of the property is null.
      if (document.fullscreenElement) {
        setFullscreen(true)
      } else {
        setFullscreen(false)
      }
    })
  }, [])

  useEffect(() => {
    obtainVideo()
    createStatus()
    // obtainFavorites()
  }, [])

  useEffect(() => {
    // Lock video settings
    if (playedPercentage >= 15 && !isVideoLocked) {
      // const interceptorId = rax.attach()
      if (
        albumName.includes('MIAZGA') ||
        albumName.includes('Szpagat') ||
        albumName.includes('PIGUŁCE') ||
        albumName.includes('MIAZGA w pigułce') ||
        challengeMode
      ) {
        setVideoLocked(true)
        setVideosLocked()
      }
    }

    // Watched video settings
    if (playedPercentage >= 80 && !isVideoWatched) {
      if (
        albumName.includes('MIAZGA') ||
        albumName.includes('MIAZGA w pigułce') ||
        albumName.includes('PIGUŁCE') ||
        albumName.includes('Szpagat') ||
        challengeMode
      ) {
        setVideoWatched(true)
        setVideosWatched()
      }
    }
  }, [playedPercentage])

  useEffect(() => {
    // After status create request
    if (isStatusCreated && videoId) {
      // obtainAllFolderStatuses()
      getCurrentVideoInfo()
    }
  }, [isStatusCreated])

  useEffect(() => {
    if (playerContainerRef.current) {
      hideControls()
    }
  }, [playerContainerRef])

  const throttle = (callback: any, interval: any) => {
    let enableCall: boolean = true

    return (...args: any) => {
      if (!enableCall) return

      enableCall = false
      callback.apply(throttle, args)
      setTimeout(() => (enableCall = true), interval)
    }
  }

  const hideControls = () => {
    let timeout: any
    const duration: number = 3000

    const listenerFunction = () => {
      setHideControls(false)
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        setHideControls(true)
      }, duration)
    }

    playerContainerRef.current.addEventListener(
      'mousemove',
      throttle(listenerFunction, 500)
    )

    window.onorientationchange = (event: any) => {
      if (event.currentTarget.orientation == 90 && isMobile) {
        setHorizontalMobile(true)
        throttle(listenerFunction, 500)
      } else {
        setHorizontalMobile(false)
      }
    }

    // playerContainerRef.current.addEventListener('click', () => {
    //   if (shouldHideControls && !isVideoPlaying) {
    //     setHideControls(true)
    //     playerContainerRef.current.removeEventListener('mousemove', () => {
    //       listenerFunction()
    //     })
    //   } else {
    //     listenerFunction()
    //   }
    // })
  }

  const obtainVideo = async () => {
    // const interceptorId = rax.attach()

    let video: any = await getSpecificVideo(videoId)

    setVideo(video)
  }

  // const obtainAllFolderStatuses = () => {
  //   getAllUserWatchedVideosByFolder(albumId, albumName.includes('SZPAGAT'))
  // }

  const handlePlayerProgress = (e: any) => {
    setPlayedSeconds(e.playedSeconds)
    setPlayedPercentage(e.played * 100)
  }

  function isFullScreen() {
    return (
      document.fullscreenElement ||
      playerRef.current.wrapper.mozFullScreen ||
      playerRef.current.wrapper.webkitIsFullScreen
    )
  }

  function requestFullScreen() {
    if (playerRef.current.wrapper.requestFullscreen) {
      playerRef.current.wrapper.requestFullscreen()
      playerRef.current.wrapper.appendChild(controlsRef.current)
    } else if (playerRef.current.wrapper.msRequestFullscreen) {
      playerRef.current.wrapper.msRequestFullscreen()
      playerRef.current.wrapper.appendChild(controlsRef.current)
    } else if (playerRef.current.wrapper.mozRequestFullScreen) {
      playerRef.current.wrapper.mozRequestFullScreen()
      playerRef.current.wrapper.appendChild(controlsRef.current)
    } else if (playerRef.current.wrapper.webkitRequestFullscreen) {
      playerRef.current.wrapper.webkitRequestFullscreen()
      playerRef.current.wrapper.appendChild(controlsRef.current)
    }
  }

  function exitFullScreen() {
    if (document.exitFullscreen) document.exitFullscreen()
    else if (playerRef.current.wrapper.msExitFullscreen)
      playerRef.current.wrapper.msExitFullscreen()
    else if (playerRef.current.wrapper.mozCancelFullScreen)
      playerRef.current.wrapper.mozCancelFullScreen()
    else if (playerRef.current.wrapper.webkitExitFullscreen)
      playerRef.current.wrapper.webkitExitFullscreen()
  }

  function toggleFullscreen() {
    if (isFullScreen()) exitFullScreen()
    else requestFullScreen()
  }

  const handlePictureInPictureClick = () => {
    playerRef.current.getInternalPlayer().requestPictureInPicture()
  }

  const handleTogglePlay = () => {
    setVideoPlaying(!isVideoPlaying)
  }

  const getCurrentVideoInfo = async () => {
    if (!challengeMode) {
      if (
        albumName.includes('MIAZGA w pigułce') ||
        albumName.includes('PIGUŁCE')
      ) {
        const currentVid = await getTemporaryVideoStatus(videoId, albumId)

        if (currentVid) {
          currentVid && setCurrentVideoStatus(currentVid)
        }
      } else {
        if (albumName.includes('MIAZGA') || albumName.includes('Szpagat')) {
          let currentVideo: any = await getSpecificVideoStatus(
            videoId,
            albumName.includes('Szpagat')
          )

          if (currentVideo && currentVideo.length) {
            currentVideo && setCurrentVideoStatus(currentVideo[0])
          }
        } else {
          let currentVideo: any = await getStandardVideoStatus(videoId, albumId)

          if (currentVideo) {
          }
        }
      }
    } else {
      const status: any = await getChallengeStatuses(videoId, albumId)

      status && setCurrentVideoStatus(status.data)
    }
  }

  const createStatus = async () => {
    if (!challengeMode) {
      if (
        albumName.includes('MIAZGA w pigułce') ||
        albumName.includes('PIGUŁCE')
      ) {
        const status: any = await setTemporaryVideoStatus(
          albumId,
          videoId,
          videoOrder
        )

        if (status) {
          setApiStatusId(status.data.id)
        }
      } else {
        if (albumName.includes('Szpagat') || albumName.includes('MIAZGA')) {
          const endpointUrl = albumName.includes('Szpagat')
            ? 'videostatuschallange'
            : 'videostatus'

          await axios
            .post(
              `${ApiURL}/api/${endpointUrl}/`,
              {
                album_vimeo_id: albumId,
                video_order_id: videoOrder,
                video_id: videoId,
                is_intro: false,
              },

              {
                headers: {
                  Authorization: 'Bearer ' + cookie.load('accessToken'),
                },
              }
            )
            .then((response) => {
              setApiStatusId(response.data.id)
            })
            .catch((error) => {})
        } else {
          const status: any = await standardVideoCreateStatus(
            albumId,
            videoId,
            videoOrder
          )

          if (status) {
            setApiStatusId(status.data.id)
          }
        }
      }
    } else {
      const status: any = await setChallengeVideoStatus(
        albumId,
        videoId,
        videoOrder
      )
      await setApiStatusId(status.id)
    }

    setStatusCreated(true)
  }

  const handleForwardRewindButton = (mode: string) => {
    if (playerRef.current) {
      switch (mode) {
        case 'forward':
          if (
            !albumName.includes('MIAZGA') &&
            !albumName.includes('Szpagat') &&
            !albumName.includes('MIAZGA w pigułce') &&
            !albumName.includes('PIGUŁCE')
          ) {
            playerRef.current.seekTo(playedSeconds + 30, 'seconds')
            setPlayedSeconds(playedSeconds + 30)
          }
          break

        case 'back':
          playerRef.current.seekTo(playedSeconds - 30, 'seconds')
          setPlayedSeconds(playedSeconds - 30)
          break
        default:
          return
      }
    }
  }

  const setVideosWatched = () => {
    const date = new Date().toJSON().slice(0, 10).replace(/-/g, '/')
    const offset = getOffset()

    if (!challengeMode) {
      if (albumName.toLocaleLowerCase().includes('piguł')) {
        const setWatchedVideoStatusConfig: any = {
          method: 'patch',
          url: `${ApiURL}/api/vimeovideos/temporary_video_statuses/${currentVideoStatus.id}/set_as_watched/?offset_ms=${offset}`,
          headers: {
            Authorization: `Bearer ${cookie.load('accessToken')}`,
          },
        }

        axios(setWatchedVideoStatusConfig)
          .then((response) => {
            notify.show(
              `Gratulujemy! Trening został obejrzany! Kolejny trening odblokuje się w następny dzień treningowy!`,

              'success',
              5000
            )
          })
          .catch((error) => {
            cookie.save('watched-error', JSON.stringify(error.response))
          })
      } else {
        if (albumName.includes('Szpagat') || albumName.includes('MIAZGA')) {
          const endpointUrl = albumName.includes('Szpagat')
            ? 'videostatuschallange'
            : 'videostatus'

          const setWatchedVideoStatusConfig: any = {
            method: 'patch',
            url: `${ApiURL}/api/${endpointUrl}/${currentVideoStatus.id}/set_as_watched/?offset_ms=${offset}`,
            body: { locked_datetime: date },
            'axios-retry': {
              retries: 3,
            },
            headers: {
              Authorization: `Bearer ${cookie.load('accessToken')}`,
            },
          }

          axios(setWatchedVideoStatusConfig)
            .then((response) => {
              notify.show(
                `Gratulujemy! Trening został obejrzany! Kolejny trening odblokuje się w następny dzień treningowy!`,

                'success',
                5000
              )
            })
            .catch((error) => {
              cookie.save('watched-error', JSON.stringify(error.response))
            })
        } else {
          setStandardVideoWatched(currentVideoStatus.id)
        }
      }
    } else {
      setChallengeVideoWatched(currentVideoStatus.id)
    }
  }

  const setVideosLocked = () => {
    const date = new Date().toJSON().slice(0, 10).replace(/-/g, '/')
    const offset = getOffset()
    const endpointUrl = albumName.includes('Szpagat')
      ? 'videostatuschallange'
      : 'videostatus'

    if (!challengeMode) {
      if (albumName.toLocaleLowerCase().includes('piguł')) {
        const setLockedVideoStatusConfig: any = {
          method: 'patch',
          url: `${ApiURL}/api/vimeovideos/temporary_video_statuses/${currentVideoStatus.id}/set_as_locked/?offset_ms=${offset}`,
          headers: {
            Authorization: `Bearer ${cookie.load('accessToken')}`,
          },
        }

        axios(setLockedVideoStatusConfig)
          .then((response) => {})
          .catch((error) => {})
      } else {
        if (albumName.includes('Szpagat') || albumName.includes('MIAZGA')) {
          const setLockedVideoStatusConfig: any = {
            method: 'patch',
            url: `${ApiURL}/api/${endpointUrl}/${currentVideoStatus.id}/set_as_locked/?offset_ms=${offset}`,
            body: { locked_datetime: date },
            'axios-retry': {
              retries: 3,
            },
            headers: {
              Authorization: `Bearer ${cookie.load('accessToken')}`,
            },
          }

          axios(setLockedVideoStatusConfig)
            .then((response) => {})
            .catch((error) => {})
        } else {
          setStandardVideoLocked(currentVideoStatus.id)
        }
      }
    } else {
      setChallengeVideoLocked(currentVideoStatus.id)
    }
  }

  const toggleFavorite = () => {
    toggleFavoriteVideo(videoId, albumId)
  }

  return (
    <GenericBackgroundLayer
      ref={playerContainerRef}
      fDir={'column'}
      justify={'start'}
      className={`${
        appContext.appState.theme == 'light' ? 'light' : 'standard'
      } player`}
    >
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={true}
          dietCartClick={null}
          handleClick={() => history.goBack()}
        />
      )}
      {challengeMode ? (
        <Navigation />
      ) : (
        <NavigationBar
          isPlayerView={true}
          backButtonAction={() => history.goBack()}
        />
      )}
      <GenericTextSpan
        className={`${
          appContext.appState.theme == 'light' ? 'light' : ''
        }player-video-name`}
        fSize={'2.3rem'}
        fWeight={'200'}
        margin={'3% 0 3% 0%'}
      >
        {videoName ? videoName : video && video.name}
      </GenericTextSpan>

      <PlayerBox isMobile={isMobile}>
        <ReactPlayer
          className="player"
          style={playerInlineStyles}
          playing={isVideoPlaying}
          ref={playerRef}
          url={video && video.download && video.download[1].link}
          pip={true}
          progressInterval={1000}
          onProgress={handlePlayerProgress}
          config={{
            file: {
              attributes: {
                playsInline: true,
                controlsList: 'nofullscreen',
                onContextMenu: (e: any) => e.preventDefault(),
              },
            },
          }}
        >
          {/* Below Controls visible on fullscreen, placed inside video component */}

          {/* <PlayerControls
              controlsRef={controlsRef}
              playedPercentage={playedPercentage}
              handleForwardRewindButton={handleForwardRewindButton}
              handleTogglePlay={handleTogglePlay}
              isVideoPlaying={isVideoPlaying}
              handleClickFullscreen={toggleFullscreen}
              isFullscreen={isFullscreen}
              playedSeconds={playedSeconds}
              handlePictureInPictureClick={handlePictureInPictureClick}
              videoName={video && video.name}
              videoDuration={video && video.duration}
              albumName={albumName}
            /> */}
        </ReactPlayer>

        {/* Below Controls visible outside fullscreen */}
        <PlayerControls
          controlsRef={controlsRef}
          playedPercentage={playedPercentage}
          handleForwardRewindButton={handleForwardRewindButton}
          handleTogglePlay={handleTogglePlay}
          isVideoPlaying={isVideoPlaying}
          handleClickFullscreen={toggleFullscreen}
          isFullscreen={isFullscreen}
          playedSeconds={playedSeconds}
          handlePictureInPictureClick={handlePictureInPictureClick}
          videoName={videoName ? videoName : video && video.name}
          videoDuration={video && video.duration}
          albumName={albumName}
          shouldHideControls={shouldHideControls}
          isHorizontalMobile={isHorizontalMobile}
          toggleFavorite={toggleFavorite}
          isFav={isFav}
        />
      </PlayerBox>
    </GenericBackgroundLayer>
  )
}

export default VideoPlayer
